import { render } from "./ratingView.vue?vue&type=template&id=454eea83"
import script from "./ratingView.vue?vue&type=script&lang=js"
export * from "./ratingView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__